import { Trans } from '@lingui/react'
import { useWatch } from 'react-hook-form'

import { FormSubmitButton } from '@twisto/components/atoms/button'
import { CodeInput } from '@twisto/components/molecules/code-input'

import * as styles from './otp-form-content.styles'

export const fieldNames = {
  code: 'code',
} as const

const DEFAULT_CODE_LENGTH = 6

export const OtpFormContent = () => {
  const code = useWatch({ name: fieldNames.code })
  const isDisabled = code.length < DEFAULT_CODE_LENGTH

  return (
    <>
      <div css={styles.codeFieldSection}>
        <CodeInput
          autoFocus
          required
          showChars
          maxLength={DEFAULT_CODE_LENGTH}
          minLength={DEFAULT_CODE_LENGTH}
          name={fieldNames.code}
        />
      </div>
      <FormSubmitButton disabled={isDisabled}>
        <Trans id="flow.otpVerificationEmailStep.submitButton" />
      </FormSubmitButton>
    </>
  )
}
